import intersectionObserverTriggers from "../utils/intersection-observer";

const pageTitles = Array.from(
  document.querySelectorAll(".hero-section h1, .hero-section .h1")
);

if (null !== pageTitles && pageTitles.length) {
  pageTitles[0].classList.add("-in-view");
}

const sectionTitles = Array.from(
  document.querySelectorAll(".anim-block-title, .banner-title")
);

// animate all large block titles on scroll
intersectionObserverTriggers(sectionTitles, 0.8, "-30px 0px 0px 0px");
